import { FC, memo, ReactElement } from "react";
import { Link } from "react-router-dom";

import { ReactComponent as LogoSVG } from "assets/images/common/logo.svg";
import image from "assets/images/login.png";

import { PAGES } from "utils/links";

type PropsType = {
  children?: ReactElement;
};

const LayoutLogin: FC<PropsType> = ({ children }) => {
  return (
    <main className={"login-page"}>
      <div className={"login-page__card"}>
        <Link to={PAGES.LOGIN} className={"login-page__logo"}>
          <LogoSVG />
        </Link>

        {children}

        <p className={"login-page__copyright"}>© 2026 WOLKIS. All rights reserved.</p>
      </div>

      <img src={image} alt="login image" className={"login-page__image"} />
    </main>
  );
};

export default memo(LayoutLogin);
